import levels from './lexileLevels.json';
export { levels as LEXILE_LEVELS };
export const parseLexileMeasure = (value) => {
  if (value == null || String(value).trim() === '') return null;
  const normalized = String(value).trim().toUpperCase();
  if (normalized === 'BR') return 0;
  const match = normalized.match(/^(BR\s*)?(-?\d+(?:\.\d+)?)\s*L?$/);
  if (!match) return null;
  const score = Math.round(Number(match[2]));
  return match[1] ? -Math.abs(score) : score;
};
export const formatLexileMeasure = (score) => score == null ? 'Not available' : score < 0 ? `BR ${Math.abs(score)}L` : score === 0 ? 'BR' : `${score}L`;
export const getLexileReport = (value) => {
  const score = parseLexileMeasure(value);
  if (score == null) return null;
  const current = levels.find((level) => score <= level.max) || levels[levels.length - 1];
  const next = levels[current.level] || null;
  const lower = current.level === 1 ? Math.min(-201, score) : levels[current.level - 2].max + 1;
  const target = next ? current.max + 1 : current.max;
  const progress = Math.min(100, Math.max(0, (score - lower) / (target - lower) * 100));
  const cefrIndex = [535, 800, 1090, 1320, 1460, Infinity].findIndex((max) => score <= max);
  return { score, current, next, lower, target, progress, gap: Math.max(0, target - score), cefrIndex, cefr: ['A1','A2','B1','B2','C1','C2'][cefrIndex] };
};
export const getTestDuration = (test) => {
  const start = new Date(test?.test_date).getTime();
  const end = new Date(test?.test_end_date).getTime();
  return test?.test_date && test?.test_end_date && Number.isFinite(start) && Number.isFinite(end) && end >= start
    ? Math.max(1, Math.round((end - start) / 60000)) : null;
};
